import { AxiosResponse } from 'axios'
import IPackReportApiResponse from 'src/system/content/api/IPackReportApiResponse'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'
import IReportingService from 'src/system/content/services/IReportingService'

export class ReportingService implements IReportingService {
  constructor(private readonly remoteContentService: IRemoteContentService) {
    //
  }

  async fetchPackReport(startDate: Date): Promise<IPackReportApiResponse> {
    const response: AxiosResponse<IPackReportApiResponse> = await this.remoteContentService.request(
      'GET',
      `/api/report/packs?start_date=${startDate.toISOString()}`
    )

    return response.data
  }
}
